import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { VendPage } from './vend.page';

const routes: Routes = [
  {
    path: '',
    component: VendPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VendPageRoutingModule {}
